import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../utils/api'

/**
 * Hook para obtener la lista de periodicidades desde el backend,
 * cacheada con React Query.
 */
function usePeriodicities() {
  const {
    data: periodicities = [],
    isLoading,
    error
  } = useQuery(
    ['periodicities'],
    async () => {
      const res = await apiFetch('/api/periodicity', { credentials: 'include' })
      if (!res) return
      if (!res.ok) {
        throw new Error('Error loading periodicities')
      }
      return res.json()
    },
    {
      staleTime: 1000 * 60,
      cacheTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false
    }
  )

  return {
    periodicities,
    loading: isLoading,
    error
  }
}

export default usePeriodicities
